import CentralLink from './CentralLink.js';

const StationLinker = ({ stationId, urlSlug, metricQualifier, metricId, children, isHistoricalLink, historicalFloodStartTime}) => {

	let stationPath = '/stations/' + (urlSlug ? urlSlug : stationId);

	let acceptedQualifierMapping = {
		'Downstream Stage': 'downstream',
		'Rainfall': 'rainfall',
		'Flow': 'flow',
		'WaterTemperature': 'water-temperature'
	}

	/** Priority Order
	 * 		/:metricQualifier
	 * 		/metric/:metricId
	 * 		/historical
	 */

	if(acceptedQualifierMapping[metricQualifier]) {
		stationPath += '/' + acceptedQualifierMapping[metricQualifier];
	} else if(metricId) {
		stationPath += '/metric/' + metricId;
	} else if(isHistoricalLink) {
		stationPath += '/historical';
		if(historicalFloodStartTime) {
			stationPath += '/flood/' + historicalFloodStartTime;
		}
	}

	return <CentralLink to={stationPath}>
		{children}
	</CentralLink>;
};

export default StationLinker;